module.exports = __webpack_public_path__ + "img/01.5d5d6828.jpg";